package com.pincer.client

import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.w3c.dom.WebSocket
import com.pincer.core.Logger

/*
Browser implementations of the client's platform functions.
These used to live in pincerlibs.js, a hand-copied script in each web module. Since September 2026 they're here.
*/

actual fun mpName(): String = "JS"

// Served from this machine, e.g. by jsBrowserDevelopmentRun or a local static server
actual fun mpIsLocalDevelopment(): Boolean =
    js("typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')") as Boolean

actual class MpWebSocket actual constructor(private val url: String, private val log: Logger, private val callback: suspend (String) -> Unit) {

    private var socket: WebSocket? = null

    @OptIn(DelicateCoroutinesApi::class)
    actual fun send(message: String) {
        if (socket != null && socket!!.readyState > WebSocket.OPEN) {
            log.i("Throwing away closed socket")
            socket = null
        }
        val open = socket
        if (open != null) {
            open.send(message)
            return
        }
        log.i("Setting up WebSocket $url")
        val created = WebSocket(url)
        created.onopen    = { log.i("WebSocket Open, sending first message"); created.send(message) }
        created.onmessage = { event -> GlobalScope.launch { callback(event.data as String) } }
        created.onclose   = { log.i("WebSocket Close") }
        created.onerror   = { log.w("WebSocket Error") }
        socket = created
    }

    actual fun close() {
        try { socket?.close() }
        catch (ignored: Throwable) { }
    }

}
